// extracted by mini-css-extract-plugin
module.exports = {"keepCustomerSafe":"_2DV-o","safeCustomerBox":"_31xms"};